import React from 'react';
import styled from 'styled-components';
import { colors } from '../../styles/variables';

const AboutSection = styled.section`
  padding: 80px 24px;
`;

const SectionContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const SectionTitle = styled.h2`
  font-size: 36px;
  font-weight: 700;
  color: ${colors.primary};
  margin-bottom: 16px;
`;

const SectionSubtitle = styled.p`
  font-size: 18px;
  color: ${colors.textGray};
  margin-bottom: 48px;
`;

const AboutGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const AboutContent = styled.div``;

const ContentTitle = styled.h3`
  font-size: 24px;
  font-weight: 700;
  color: ${colors.primary};
  margin-bottom: 16px;
`;

const ContentList = styled.ul`
  list-style: none;
  margin-bottom: 24px;
`;

const ContentItem = styled.li`
  font-size: 16px;
  color: ${colors.textGray};
  margin-bottom: 8px;
  display: flex;
  align-items: flex-start;
  
  &:before {
    content: "✓";
    color: ${colors.secondary};
    font-weight: 700;
    margin-right: 8px;
  }
`;

const AboutImage = styled.div`
  border-radius: 8px;
  overflow: hidden;
  align-self: flex-start;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
  
  img {
    width: 100%;
    aspect-ratio: 16 / 9;
    object-fit: cover;
    display: block;
  }
`;

const CourseAbout = ({
  subtitle,
  forWhom,
  skills,
  imageSrc
}) => {
  return (
    <AboutSection>
      <SectionContainer>
        <SectionTitle>과정 소개</SectionTitle>
        <SectionSubtitle>{subtitle}</SectionSubtitle>
        
        <AboutGrid>
          <AboutContent>
            <ContentTitle>이런 분들에게 추천합니다</ContentTitle>
            <ContentList>
              {forWhom.map((item, index) => (
                <ContentItem key={index}>{item}</ContentItem>
              ))}
            </ContentList>
            
            <ContentTitle>이런 역량을 갖게 됩니다</ContentTitle>
            <ContentList>
              {skills.map((item, index) => (
                <ContentItem key={index}>{item}</ContentItem>
              ))}
            </ContentList>
          </AboutContent>
          <AboutImage>
            <img src={imageSrc} alt="과정 소개" />
          </AboutImage>
        </AboutGrid>
      </SectionContainer>
    </AboutSection>
  );
};

export default CourseAbout;
